import { useSetRecoilState } from 'recoil';
import { loadingState, loadingText } from '../../../states/loadingState';
import apiClient from '../../../utils/lib/apiClient';
import { useCallback } from 'react';
import { convertDateFormat } from '../../../utils/functions/formatting';
export const useGetMorimatsuCalendar = () => {
  const setLoadingAnimation = useSetRecoilState(loadingState);
  const setLoadingText = useSetRecoilState(loadingText);

  const getIsHolidayList = useCallback(
    async (fromDate: string, toDate: string) => {
      // setLoadingAnimation(true);
      // setLoadingText("取得中...");
      const params = {
        fromDate: fromDate,
        toDate: toDate,
      };
      const queryParams = new URLSearchParams(params).toString();
      try {
        const res = await apiClient.get(
          `/morimatsu/getIsHolidayList?${queryParams}`
        );
        const data = res.data;

        return data.map((d: any) => {
          return {
            date: d.date,
            isHoliday: d.isHoliday,
            shortDate: convertDateFormat(d.date),
          };
        });
      } catch (e) {
        window.alert('エラーが発生しました' + e);
        return null;
      } finally {
        // setLoadingAnimation(false);
        // setLoadingText("");
      }
    },
    [loadingState, loadingText]
  );

  return { getIsHolidayList };
};
